import { render, staticRenderFns } from "./ShopsTablePageAdmin.vue?vue&type=template&id=1e2154f9"
import script from "./ShopsTablePageAdmin.vue?vue&type=script&lang=js"
export * from "./ShopsTablePageAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports